import './App.css';
import NavBar from './components/ui/Navbar/Navbar';
import { BrowserRouter, Route, Routes, } from "react-router-dom";
import SignupPage from './components/signup_page/signup-page';
import HomePage from './components/HomePage/HomePage';
import Footer from './components/ui/Footer/Footer';
import React from 'react';
function App() {
  return (
    <BrowserRouter>
      <div className='App'>
        {/* <NavBar/> */}
        <div className='main'>
          <Routes>
            <Route path={'/'} element={<HomePage />} />
            <Route path={'/register'} element={<SignupPage />} />
            <Route path='*' element={
              <div>
                <h1 style={{ color: 'white' }}>Coming soon...</h1>
              </div>
            } />
          </Routes>
        </div>
        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
